class PaymentSipsController {
  constructor ($log, VehicleService, ProductService, VoucherService, UserService, Localization, StoreTypes, $sce, $state, $window, $location) {
    'ngInject'
    this.vehicleService = VehicleService
    this.productService = ProductService
    this.voucherService = VoucherService
    this.userService = UserService
    this.$sce = $sce
    this.$state = $state
    this.$log = $log
    this.$location = $location
    this.activeFormSips = false
    this.showBlock = true
    this.$window = $window
    this.isProcessing = false
    this.type = Localization.getLocalizedAppConfig().type
    this.StoreTypes = StoreTypes
  }

  $onInit () {
    this.buyProductSips()
  }

  buyProductSips () {
    this.isProcessing = true
    const vin = this.vehicleService.getCurrentVin()
    if (this.type === this.StoreTypes.HELIOS ||
      this.type === this.StoreTypes.MYRENAULT ||
      this.type === this.StoreTypes.ONE) {
      this.$window.localStorage.setItem('token', this.$location.search().token)
    }
    return this.productService.buyProduct(vin, this.productRef, this.purchaseInfos, this.voucherInfos)
    .then((res) => {
      this.isProcessing = false
      this.response = res
      if (this.response.sipsForm === 'OK') {
        // FREE Product
        this.$log.debug('buyProductSips > isPurchaseVoucher = ' + this.voucherInfos.isPurchaseUsingVoucher)
        this.$state.go('managePurchase.confirmation', {productId: this.productRef, free: true, status: 'Delivered', voucher: this.voucherInfos.isPurchaseUsingVoucher, reduction: this.voucherInfos.amountReduction})
      } else {
        this.activeFormSips = true
        this.sipsForm = this.$sce.trustAsHtml(this.response.sipsForm)
      }
      // MAJ SessionStorage
      if (this.purchaseInfos.isPro) {
        this.userService.setCurrentCompany(this.purchaseInfos.buyer.company)
      }
    }, (err) => {
      this.isProcessing = false
      this.validForm = false
      this.errorPurchase = {
        message: 'error.' + err.data.meta.code,
        cause: err
      }
      this.$log.error('buyProduct sips error', err)
    })
  }

  goBack () {
    this.$window.history.back()
    // Annuler la consommation du code voucher
    if (this.voucherInfos.voucherCode && this.voucherInfos.isPurchaseUsingVoucher === true) {
      this.isProcessing = true
      return this.voucherService.cancelVoucherCode(this.voucherInfos.voucherCode)
      .then((res) => {
        this.error = null
        this.isProcessing = false
      }, (err) => {
        this.isProcessing = false
        this.$log.error('error cancelVoucher', err)
        this.error = err
      })
    }
  }

}

export default PaymentSipsController



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/my-purchase/buy-product/payment-sips/payment-sips.controller.js